export enum datePickerPickers {
  DATE = 'date',
  WEEK = 'week',
  MONTH = 'month',
}
